import { render, staticRenderFns } from "./FactoringsReport.vue?vue&type=template&id=9b56cfc6&scoped=true&"
import script from "./FactoringsReport.vue?vue&type=script&lang=js&"
export * from "./FactoringsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b56cfc6",
  null
  
)

export default component.exports